import AcceptByTechnicianModal from './AcceptByTechnicianModal';
const meta = {
    title: 'Features/Inspections/ConflictsListing/AcceptByTechnicianModal',
    component: AcceptByTechnicianModal,
    args: {
        isOpen: true,
        isSubmitting: false,
        isLoading: false,
        hasError: false,
        summary: {
            groupsTotal: 4,
            technicians: [
                { id: 1, name: 'Aaron Mendez', groupsResolvable: 3 },
                { id: 2, name: 'Beth Okoro', groupsResolvable: 1 },
                { id: 3, name: 'Chris Vaughn', groupsResolvable: 0 }
            ]
        },
        onClose: () => undefined,
        onConfirm: () => Promise.resolve()
    }
};
export default meta;
/** Technicians loaded; picking one reveals how many groups it would clear. */
export const Default = {};
/** The summary request is still in flight. */
export const Loading = {
    args: { isLoading: true, summary: null }
};
/** The summary request failed — surfaced inline rather than as a toast, because
 * the dialog is already open and has nowhere useful to send the user. */
export const LoadFailed = {
    args: { hasError: true, summary: null }
};
/** Confirm is in flight: both buttons lock so the run cannot be double-submitted. */
export const Submitting = {
    args: { isSubmitting: true }
};
/** Every technician on the inspection has nothing acceptable, so Confirm stays
 * disabled whichever one is selected. */
export const NothingToAccept = {
    args: {
        summary: {
            groupsTotal: 2,
            technicians: [
                { id: 1, name: 'Aaron Mendez', groupsResolvable: 0 },
                { id: 2, name: 'Beth Okoro', groupsResolvable: 0 }
            ]
        }
    }
};
